"use client";

import Image from "next/image";
import rezervator from "../../public/images/rezervator.png";
import thumbnail from "../../public/images/thumbnail.svg";
import { useGlobalStore } from "@/zustand/initStore";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { config } = useGlobalStore();

  return (
    <div className="w-screen h-screen overflow-hidden">
      <div className="flex items-center justify-center w-full h-full">
        <div className="hidden md:flex items-center justify-between flex-col w-[60%] bg-secondary h-full px-8 py-6 gap-4">
          {config && (
            <Image
            // @ts-ignore
              src={config?.logo}
              width={70}
              height={70}
              alt="logo_image_of_login"
              className="self-start"
              priority
              unoptimized
            />
          )}
            <Image
              src={thumbnail}
              width={600}
              height={200}
              alt="thumbnail_image_of_login"
              priority
            />
            <Image
              src={rezervator}
              width={150}
              height={500}
              alt="thumbnail_image_of_login"
              priority
            />

        </div>

        {children}
      </div>
    </div>
  );
}
